import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import appActions from "@redux/app";
import { AccountService, FirebaseService } from "@services";
import { SplashScreen } from "../../components";

class Logout extends Component {
	componentDidMount = () => {
		const { onLogout, resetAccount } = this.props;

		AccountService.logout().finally(() => {
			this.resetGlobalCache();
			localStorage.removeItem("t");
			window.userId = undefined;
			FirebaseService.removeToken();
			resetAccount();
			onLogout();
		});
	};

	resetGlobalCache = () => {
		global.rkc = undefined;
	};

	render() {
		return <SplashScreen />;
	}
}

const mapDispatchToProps = dispatch => ({
	resetAccount: bindActionCreators(appActions, dispatch).resetAccount,
});

Logout.propTypes = {
	onLogout: PropTypes.func.isRequired,
	resetAccount: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Logout);
